import { Colors, Icon, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const outerRow = {
  marginRight: 'padding_16',
  gap: 'padding_4',
  justifyContent: 'flex-start',
  alignItems: 'start',
  paddingTop: 'padding_8',
  paddingBottom: 'padding_8',
};

const Header = () => {
  return (
    <FlexRow sx={outerRow}>
      <Icon name={Icon.Name.Calendar} fill={Colors.TextQuiet} />
      <Text.SmallLabel color={Colors.TextQuiet}>Notes</Text.SmallLabel>
    </FlexRow>
  );
};

export default Header;
